// API Configuration

// Base URL from environment (REW-822: rewards-admin-service; includes TRAFFIC_PREFIX)
const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  'http://localhost:8001/services/rewards-admin-service';

export const API_CONFIG = {
  baseURL: BASE_URL,
  timeout: 30000, // 30 seconds
  retries: 3,
  retryDelay: 1000,
};

// API Endpoints (relative to BASE_URL — flat /api/v1/* on rewards-admin-service)
export const API_ENDPOINTS = {
  // Admin endpoints
  admin: {
    partners: '/api/v1/partners',
    partnerBulkOffers: (partnerId: number) => `/api/v1/partners/${partnerId}/offers/bulk`,
    partnerBulkRemove: (partnerId: number) =>
      `/api/v1/partners/${partnerId}/offers/bulk-remove`,
    partnerBulkReplace: (partnerId: number) =>
      `/api/v1/partners/${partnerId}/offers/bulk-replace`,
    partnersBulkOffers: '/api/v1/partners/bulk/offers',
    partnersBulkRemove: '/api/v1/partners/bulk/offers/remove',
    partnersBulkReplace: '/api/v1/partners/bulk/offers/replace',
    partnerConfig: (partnerId: string) => `/admin/partners/${partnerId}/configuration`,
    rewards: '/api/v1/catalog',
    rewardDetail: (rewardId: string) => `/api/v1/catalog/${rewardId}`,
    rewardMetadata: '/api/v1/catalog/metadata',
    rewardPools: '/api/v1/catalog/pools',
    offers: '/api/v1/offers',
    offerDetail: (offerId: string) => `/api/v1/offers/${offerId}`,
    offersBulk: '/admin/offers/bulk',
    fulfillments: '/api/v1/fulfillments',
    fulfillmentStatusCounts: '/api/v1/fulfillments/status-counts',
    fulfillmentDetail: (fulfillmentId: string) => `/api/v1/fulfillments/${fulfillmentId}`,
    fulfillmentRetry: (fulfillmentId: string) =>
      `/api/v1/fulfillments/${fulfillmentId}/retry`,
    fulfillmentRefund: (fulfillmentId: string) =>
      `/api/v1/fulfillments/${fulfillmentId}/refund`,
    jobs: '/api/v1/jobs',
    jobDetail: (jobName: string) => `/api/v1/jobs/${jobName}`,
    jobRun: (jobName: string) => `/api/v1/jobs/${jobName}/run`,
    benepassTransfers: '/api/v1/benepass-transfers',
    benepassTransfersSummary: '/api/v1/benepass-transfers/summary',
    benepassTransfersSummaryByPartner: '/api/v1/benepass-transfers/summary/by-partner-product',
    incommCards: '/api/v1/incomm-cards',
    incommCardsSummary: '/api/v1/incomm-cards/summary',
    incommCardsSummaryByPartner: '/api/v1/incomm-cards/summary/by-partner',
    incommCardDetail: (eligibleParticipantId: number | string) =>
      `/api/v1/incomm-cards/${encodeURIComponent(String(eligibleParticipantId))}`,
    transactions: '/api/v1/transactions',
    transactionDetail: (transactionId: string) => `/api/v1/transactions/${transactionId}`,
    paperJournalUploads: '/api/v1/paper-journal/uploads',
    paperJournalUploadRows: (fileSha256: string) =>
      `/api/v1/paper-journal/uploads/${encodeURIComponent(fileSha256)}`,
    /** Support lookup — exactly one of ref_user_id or eligible_participant_id as query param. */
    paperJournalRows: '/api/v1/paper-journal',
    marketingBanners: '/api/v1/marketing-banners',
    marketingBannerDetail: (id: string) => `/api/v1/marketing-banners/${id}`,
    analytics: '/admin/analytics/dashboard',
    partnerAnalytics: (partnerId: string) => `/admin/analytics/partners/${partnerId}`,
    exports: (exportType: string) => `/admin/exports/${exportType}`,
    // Dashboard aggregation endpoints
    dashboardStats: '/api/v1/dashboard/stats',
    dashboardPointsActivity: '/api/v1/dashboard/points-activity',
    dashboardTopRewards: '/api/v1/dashboard/top-rewards',
    dashboardRecentActivity: '/api/v1/dashboard/recent-activity',
    // Audit endpoints
    auditLogs: '/api/v1/audit-logs',
    auditLogsBatch: '/api/v1/audit-logs/batch',
    auditLogDetail: (auditId: string) => `/api/v1/audit-logs/${auditId}`,
  },
  // Internal endpoints (existing)
  internal: {
    transactions: '/internal/transactions',
  },
  // User endpoints (existing)
  user: {
    status: '/api/v1/status',
    history: '/api/v1/history',
  },
};

export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.baseURL}${endpoint}`;
};
